import "../App.css";
import {
  tutorial2Binary1,
  tutorial2Binary2,
  tutorial2Binary3,
  tutorial2Binary4,
  tutorial2Binary5,
  tutorial2Binary6,
  tutorial2Binary7,
  tutorialButtonNextPage,
  tutorialButtonPreviousPage,
  tutorialButtonStartLevel,
  tutorialTitle
} from "../strings";

function Tutorial2Binary({ finishTutorial, page, handleNext, handlePrevious }) {

  const maxPages = 4; // Note that the first page has index 0. This means maxPages-1 is the last page.

  return (
    <div>
      <div className="tutorial-title">
        {tutorialTitle}
      </div>
      <div className="tutorial-body">
        {page === 0 && 
          <div>
            {tutorial2Binary1}
            <br></br>&nbsp;<br></br>
            {tutorial2Binary2}
          </div>
        }
        {page === 1 && 
          <div>
            {tutorial2Binary3}
          </div>
        }
        {page === 2 && 
          <div>
            {tutorial2Binary4}
            <br></br>&nbsp;<br></br>
            {tutorial2Binary5}
          </div>
        }
        {page === 3 && 
          <div>
            {tutorial2Binary6}
            <br></br>&nbsp;<br></br>
            {tutorial2Binary7}
          </div>
        }
      </div>

      {/* Button to start level. */}
      {page === (maxPages-1) && 
        <button
        onClick={finishTutorial}
          className="tutorial-next-button"
        >
        {tutorialButtonStartLevel}
        </button>
      }

      {/* Button to go to previous page. */}
      {page > 0 && 
        <button
          onClick={handlePrevious}
          className="tutorial-previous-button"
        >
        {tutorialButtonPreviousPage}
        </button>
      }

      {/* Button to go to next page. */}
      {page < (maxPages-1) && 
        <button
          onClick={handleNext}
          className="tutorial-next-button"
        >
        {tutorialButtonNextPage}
        </button>
      }
    </div>
  );
}

export default Tutorial2Binary;
